export default __webpack_public_path__ + "svg/calendar/2025/2/abril.svg?df3141c1";